<script>
  import MTableHeaderDefault from 'components/Data/Tables/MTable/headers/MTableHeaderDefault';
  import MTableCellDropdownTrigger from 'components/Data/Tables/MTable/cells/MTableCellDropdownTrigger';
  import MTableRowDropdownWrapper from 'components/Data/Tables/MTable/dropdown/MTableRowDropdownWrapper';

  const DROPDOWN_SLOT_NAME = 'dropdown';

  export default {
    name: 'MTableDropdownMixin',
    props: {
      isDropdownEnabledPredicate: {
        type: Function,
        default: () => true
      }
    },
    data () {
      return {
        openedRowsKeys: []
      };
    },
    computed: {
      dropdownSlotContent () {
        return this.$scopedSlots[DROPDOWN_SLOT_NAME];
      },
      withDropdown () {
        return Boolean(this.dropdownSlotContent && this.dropdownSlotContent());
      }
    },
    watch: {
      uniqueOrderedHash (currentState, prevState) {
        if (currentState !== prevState) {
          this.openedRowsKeys = [];
        }
      }
    },
    mounted () {
      if (this.withDropdown) {
        this.registerAfterRowRenderedProcessor(this.dropdownRowColumnProcessor);
        this.registerCellEventsListener('triggerDropdown', this.handleDropdownTrigger);
      }
    },
    methods: {
      getDropdownTriggerColumnParams () {
        if (this.withDropdown) {
          return this.fillDefaultColumnData({
            itemKey: 'dropdowned',
            headerComponent: MTableHeaderDefault,
            cellComponent: MTableCellDropdownTrigger,
            align: 'center',
            minWidth: 24,
            resizable: false,
            static: true,
            uniqueKeyAttr: this.uniqueKeyAttr,
            isDropdownEnabledPredicate: this.isDropdownEnabledPredicate,
            on: {
              triggerDropdownState: this.handleDropdownTrigger,
              triggerDropdown: this.handleDropdownTrigger
            }
          });
        }
        return null;
      },
      dropdownRowColumnProcessor (rows, h, tableRow, rowIndex, isNestedTable) {
        if (!this.isDropdownEnabledPredicate(tableRow) || isNestedTable) {
          return rows;
        }

        const dropdownComponent = this.$scopedSlots[DROPDOWN_SLOT_NAME];

        const dropdownRow = h(
          MTableRowDropdownWrapper,
          {

            // key to rerender dropdown when rowData changed (F.E. page changed)
            key: `dropdown-${tableRow[this.uniqueKeyAttr]}-${rowIndex}`,
            slot: 'table-content',
            props: {
              columnsCount: 12,
              index: rowIndex,
              openedRowsKeys: this.openedRowsKeys,
              uniqueKeyAttr: this.uniqueKeyAttr,
              tableRow
            },
            scopedSlots: {
              default: dropdownComponent
            }
          },
          []
        );

        return [...rows, dropdownRow];
      },
      handleDropdownTrigger (tableRow) {
        // do nothing if dropdown is disabled
        if (!this.isDropdownEnabledPredicate(tableRow)) {
          return;
        }

        const rowUniqueKey = tableRow[this.uniqueKeyAttr];
        if (this.openedRowsKeys.includes(rowUniqueKey)) {
          return this.openedRowsKeys.splice(this.openedRowsKeys.indexOf(rowUniqueKey), 1);
        }
        this.openedRowsKeys.push(rowUniqueKey);
      }
    }
  };

</script>
